import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fields"]

  toggle(event) {
    if (event.target.checked) {
      this.fieldsTarget.classList.remove("hidden")
    } else {
      this.fieldsTarget.classList.add("hidden")
    }
  }
}
